/* eslint-disable */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable linebreak-style */
/* eslint-disable eol-last */
/* eslint-disable quotes */
import API from "../api";
import urls from "../api/urls";

/**
 * Common download function for reports
 * @param {string} url - The download URL
 * @param {Object} params - Query parameters for the download
 * @param {string} filename - Default filename for the download
 * @param {string} method - HTTP method (GET or POST)
 * @returns {Promise<void>}
 */
export const downloadReport = async (url, params, filename = "report", method = "GET") => {
  try {
    // Construct query string for GET requests
    if (method === "GET") {
      const queryString = new URLSearchParams(params).toString();
      const fullUrl = `${url}?${queryString}`;

      const response = await API.Api(fullUrl).getCustomHeader();

      console.log('api resp--->', response?.response)

      if (response?.status) {
        // Create blob from response
        const blob = new Blob([response.response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        // Create download link
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${filename}_${new Date().toISOString().split("T")[0]}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        throw new Error(response?.message || "Download failed");
      }
    } else {
      // For POST requests
      const response = await API.Api(url).postWithHeader(params);

      if (response?.status) {
        const blob = new Blob([response.response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${filename}_${new Date().toISOString().split("T")[0]}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        throw new Error(response?.message || "Download failed");
      }
    }
  } catch (error) {
    console.error("Download error:", error);
    throw error;
  }
};

/**
 * Download Pendency Hub Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadControlTowerHubReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    currentStatus: params.currentStatus,
    destinationHubId: params.destinationHubId,
    originHubId: params.originHubId
  };
  //remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_CONTROL_TOWER_HUB_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Incoming Shipment Pendency Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadIncomingShipmentControlTowerReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    currentStatus: params.currentStatus,
    destinationHubId: params.destinationHubId,
    originHubIdList: params.originHubIdList
  };
  //remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_INCOMING_SHIPMENT_PENDENCY_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download VayuQuickPro Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadVayuQuickProReport = async (params) => {
  const downloadParams = {
    bookingHubIds: params.bookingHubIds,
    destinationHubIds: params.destinationHubIds,
    startDate: params.startDate,
    endDate: params.endDate
  };
  //remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_VAYUQUICK_PRO_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download VayuQuick Pincode Mapping list as CSV (respects the active filters).
 * The vayuquick endpoints require the Bearer token, so this uses an authenticated
 * blob download rather than window.open.
 * @param {Object} filters - Same filters used by the list (fromPincode, toPincode, city, state, serviceType, isBookingOnly, isActive)
 * @returns {Promise<void>}
 */
export const downloadVayuquickPincodes = async (filters = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(filters).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = queryString
    ? `${urls.EXPORT_VAYUQUICK_SERVICEABILITY}?${queryString}`
    : urls.EXPORT_VAYUQUICK_SERVICEABILITY;

  const response = await API.Api(fullUrl).getCustomHeader();

  if (!response?.status) {
    throw new Error(response?.message || "Download failed");
  }

  const blob = new Blob([response.response.data], { type: "text/csv;charset=utf-8;" });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = `vayuquick_pincodes_${new Date().toISOString().split("T")[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};

/**
 * Download Hub Manager Dashboard Clickable
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadClickableHubManagerDashboard = async (params) => {
  const downloadParams = {
    dateFilter: params.dateFilter,
    status: params.status,
    hubId: params.hubId,
    operationCodes: params.operationCodes,
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_CLICKABLE_HUB_MANAGER_DASHBOARD_DOWNLOAD}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download DRS By Other CP Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadDrsByOtherCpReport = async (params) => {
  const downloadParams = {
    date: params.date,
    fromDate: params.fromDate, // Backward compatibility
    hubId: params.hubId,
    fromHubId: params.fromHubId, // Backward compatibility
    toCpId: params.toCpId
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_DRS_BY_OTHER_CP}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Same Day Delivery By Other CP Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadSameDayDeliveryByOtherCpReport = async (params) => {
  const downloadParams = {
    date: params.date,
    fromDate: params.fromDate, // Backward compatibility
    hubId: params.hubId,
    fromHubId: params.fromHubId, // Backward compatibility
    toCpId: params.toCpId
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_SAME_DAY_DELIVERY_BY_OTHER_CP}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Not Inscanned By CP Clickable Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadNotInscannedByCpClickable = async (params) => {
  const downloadParams = {
    date: params.date,
    fromHubId: params.fromHubId,
    cpId: params.cpId
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_NOT_INSCANNED_BY_CP_CLICKABLE}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Delivery MIS Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadDeliveryMISReport = async (params) => {
  const downloadParams = {
    startDate: params.startDate,
    endDate: params.endDate,
    hubId: params.hubId,
    cpId: params.cpId
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_DELIVERY_MIS_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Booking Status Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadBookingStatusReport = async (params) => {
  const downloadParams = {
    fromDate: params.startDate,
    toDate: params.endDate,
    fromHubs: params.fromHubs,
    fromcps: params.fromCPs,
    awbNumbers: params.awbNumbers ? params.awbNumbers.join(",") : undefined
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_BOOKING_STATUS_DOWNLOAD_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Booked vs Audited Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadBookedVsAuditedReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    docTypes: params.docTypes ? params.docTypes.join(",") : null,
    hubids: Array.isArray(params.hubIds) ? params.hubIds.join(",") : params.hubIds,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_BOOKED_VS_AUDITED_DOWNLOAD_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");

};

/**
 * Download Audited Details Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadAuditedDetailsReport = async (params) => {
  const downloadParams = {
    bookingDate: params.bookingDate,
    ...(params.hubId && { hubId: params.hubId }),
    ...(params.cpId && { cpId: params.cpId }),
    ...(params.docType && { docType: params.docType })
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_AUDITED_DETAILS_DOWNLOAD_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Total Bookings Audit Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadTotalBookingsAuditReport = async (params) => {
  const downloadParams = {
    bookingDate: params.bookingDate,
    ...(params.hubId && { hubId: params.hubId }),
    ...(params.cpId && { cpId: params.cpId }),
    ...(params.docType && { docType: params.docType })
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_TOTAL_BOOKINGS_AUDIT_DOWNLOAD_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Booking vs Inscan Outscan Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadBookingVsInscanOutscanReport = async (params) => {
  const downloadParams = {
    fromDate: params.startDate,
    toDate: params.endDate,
    toHub: params.hubNames ? params.hubNames.join(",") : undefined,
    zones: params.zones ? params.zones.join(",") : undefined,
    bookingCp: params.cpNames ? params.cpNames.join(",") : undefined,
    awbNumbers: params.awbNumbers ? params.awbNumbers.join(",") : undefined,
    audit: params.audit && Array.isArray(params.audit) && params.audit.length > 0
      ? params.audit.join(",")
      : undefined,
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_BOOKING_VS_INSCAN_OUTSCAN_DOWNLOAD_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};
//download
/**
 * Download Incoming Bag Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadIncomingBagReport = async (params) => {
  const downloadParams = {
    startDate: params.startDate,
    endDate: params.endDate,
    fromHubs: params.fromHubs ? params.fromHubs.join(",") : undefined,
    toHubs: params.toHubs ? params.toHubs.join(",") : undefined,
    transportTypes: params.transportTypes ? params.transportTypes.join(",") : undefined
  };

  // Remove undefined values and join arrays
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_INCOMING_BAG_DOWNLOAD_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Outgoing Bag Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadOutgoingBagReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    fromHubIds: params.fromHubIds ? params.fromHubIds.join(",") : undefined,
    toHubIds: params.toHubIds ? params.toHubIds.join(",") : undefined,
    transportMode: params.transportMode,
    bagNo: params.bagNo ? params.bagNo.join(",") : undefined
  };

  // Remove undefined values and join arrays
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_OUTGOING_BAG_DOWNLOAD_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Fast Track Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadFastTrackReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    parentHubIds: params.parentHubIds ? params.parentHubIds.join(",") : undefined,
    destinationHubIds: params.destinationHubIds ? params.destinationHubIds.join(",") : undefined,
    bookingCpIds: params.bookingCpIds ? params.bookingCpIds.join(",") : undefined,
    zones: params.zones ? params.zones.join(",") : undefined,
    serviceTypes: params.serviceTypes ? params.serviceTypes.join(",") : undefined,
    bookingTypes: params.bookingTypes ? params.bookingTypes.join(",") : undefined
  };

  // Remove undefined values and join arrays
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_FASTTRACK_DOWNLOAD_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Hub Audit Entry Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadHubAuditEntryReport = async (params) => {
  const downloadParams = {
    fromDate: params.startDate,
    toDate: params.endDate,
    entryTypes: params.entryTypes ? params.entryTypes.join(",") : undefined,
    auditedHubs: params.auditedHubs ? params.auditedHubs.join(",") : undefined,
    awbNumbers: params.awbNumbers ? params.awbNumbers.join(",") : undefined,
    serviceTypes: params.serviceTypes ? params.serviceTypes.join(",") : undefined,
    travelBy: params.travelBy ? params.travelBy.join(",") : undefined
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_HUB_AUDIT_ENTRY_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Incoming LCR Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadIncomingLCRReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    ...(params.hubIds && params.hubIds.length > 0 && { toPremiseIds: Array.isArray(params.hubIds) ? params.hubIds.join(",") : params.hubIds }),
    ...(params.destinationHubId && { fromHubs: params.destinationHubId }),
    ...(params.stopLcrNums && { stopLcrNums: params.stopLcrNums }),
  };
  console.log('downloadParams (Incoming LCR):', downloadParams);
  //remove undefined value
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_INCOMING_LCR_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");

  // window.open(fullUrl, "_blank");
};
export const downloadTransitLCRReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    ...(params.destinationHubId && { toPremiseIds: params.destinationHubId }),
    ...(params.originHubId && { fromPremiseIds: params.originHubId }),
    ...(params.tripStatus && { tripStatus: params.tripStatus }),
    ...(params.stopLcrNums && { stopLcrNums: params.stopLcrNums }),
    ...(params.vehicleLcrNums && { vehicleLcrNums: params.vehicleLcrNums }),
  };
  //console.log('downloadParams (Incoming LCR):', downloadParams);
  //remove undefined value
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_LCR_TALLY_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");

  // window.open(fullUrl, "_blank");
};

export const downloadLCRTallyHistoricalReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    frompremise_id: params.fromHubId,
    topremise_id: params.toHubId,
    trip_id: params.tripId,
    stop_id: params.stopId,
    trip_status: params.tripStatus,
  };
  //console.log('downloadParams (Historical LCR):', downloadParams);
  //remove undefined value
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.LCR_TALLY_HISTORICAL_DOWNLOAD}?${queryString}`;
  window.open(fullUrl, "_blank");
};

export const downloadDetailedBagOrShipmentLCRReport = async (params) => {
  const downloadParams = {
    lcrNum: params.lcrNum,
    type: params.type,
  };
  //console.log('downloadParams (Incoming LCR):', downloadParams);
  //remove undefined value
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const isShipment = params.type && params.type.toUpperCase().includes('SHIPMENT');
  const url = isShipment ? urls.DOWNLOAD_DETAILS_SHIPMENT_REPORT : urls.DOWNLOAD_DETAILS_BAG_REPORT;
  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${url}?${queryString}`;
  window.open(fullUrl, "_blank");

};

export const downloadOutGoingLCRReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    ...(params.originHubId && params.originHubId && { fromHubs: params.originHubId }),
    ...(params.destinationHubId && { toPremiseIds: params.destinationHubId }),
    ...(params.stopLcrNums && { stopLcrNums: params.stopLcrNums }),
  };

  // ...(params.destinationHubId && params.destinationHubId && { fromHubs: params.destinationHubId }),
  // ...(params.originHubId && { toPremiseIds: params.originHubId }),

  console.log('downloadParams (Outgoing LCR):', downloadParams);
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_OUTGOING_LCR_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

export const downloadDeliverStatusReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    ...(params.originHubId && params.originHubId && { fromPremiseIds: params.originHubId }),
    ...(params.destinationHubId && { toPremiseIds: params.destinationHubId }),
    ...(params.awbSearch && { awbNumbers: params.awbSearch }),
    ...(params.currentStatus && { status: params.currentStatus }),
  };

  // ...(params.destinationHubId && params.destinationHubId && { fromHubs: params.destinationHubId }),
  // ...(params.originHubId && { toPremiseIds: params.originHubId }),

  console.log('downloadDeliverStatusReport):', downloadParams);
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_DDELIVERY_STATUS_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

export const downloadHubAuditReport = async (params) => {
  const downloadParams = {
    ...(params.awbNumbers && { documentNos: params.awbNumbers }),
  };

  // ...(params.destinationHubId && params.destinationHubId && { fromHubs: params.destinationHubId }),
  // ...(params.originHubId && { toPremiseIds: params.originHubId }),

  console.log('downloadParams (downloadHubAuditReport):', downloadParams);
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_HUB_AUDIT_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");

};
export const downloadOutscanCpInscanReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    // Accept either arrays (preferred) or comma-separated strings
    hubIds: Array.isArray(params.hubIds)
      ? params.hubIds.join(",")
      : params.hubIds,
    cpIds: Array.isArray(params.cpIds)
      ? params.cpIds.join(",")
      : params.cpIds,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_OUTSCAN_CP_INSCAN_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Inscan vs Audit Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadInscanVsAuditReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    hubids: params.hubids,
    doctypes: params.doctypes,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );


  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_INSCAN_VS_AUDIT_REPORT + '/download'}?${queryString}`;
  window.open(fullUrl, "_blank");

};

/**
 * Download Inscanned Shipments Clickable Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadInscannedShipmentsClickable = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    hubId: params.hubId,
    doctype: params.doctype,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_INSCANNED_SHIPMENTS_CLICKABLE_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Audited Shipments Clickable Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadAuditedShipmentsClickable = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    hubId: params.hubId,
    doctype: params.doctype,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_AUDITED_SHIPMENTS_CLICKABLE_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Not Audited Shipments Clickable Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadNotAuditedShipmentsClickable = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    hubId: params.hubId,
    doctype: params.doctype,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_NOT_AUDITED_SHIPMENTS_CLICKABLE_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Total Assigned Clickable Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadTotalAssignedClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    hubId: params.hubId,
    type: params.type,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_TOTAL_ASSIGNED_CLICKABLE_REPORT}/download?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Inscanned At Transit Clickable Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadInscannedAtTransitClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    hubId: params.hubId,
    type: params.type,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_INSCANNED_AT_TRANSIT_CLICKABLE_REPORT}/download?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Inscanned Clickable Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadInscannedClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    hubId: params.hubId,
    type: params.type,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_INSCANNED_CLICKABLE_REPORT}/download?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Hub Inscanned Clickable Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadHubInscannedClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    hubId: params.hubId,
    type: params.type,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_HUB_INSCANNED_CLICKABLE_REPORT}/download?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Total Audited Clickable Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadTotalAuditedClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    hubId: params.hubId,
    type: params.type,
  };
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_TOTAL_AUDITED_CLICKABLE_REPORT}/download?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download CP Outscan vs Hub Inscan Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadCpOutscanVsHubInscanReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    hubIds: params.hubIds ? params.hubIds.join(",") : undefined,
    cpIds: params.cpIds ? params.cpIds.join(",") : undefined
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_CP_OUTSCAN_VS_HUB_INSCAN_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};


/**
 * Download Control Tower Report A3
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadControlTowerReportA3 = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    statuses: params.status && Array.isArray(params.status) ? params.status.join(",") : params.status,
    originHubIds: params.originHubIds && params.originHubIds.length > 0 ? params.originHubIds.join(",") : undefined,
    latestStatusTimeFrom: params.latestStatusTimeFrom,
    latestStatusTimeTo: params.latestStatusTimeTo,
    movementTypes: params.movementTypes && Array.isArray(params.movementTypes) ? params.movementTypes.join(",") : params.movementTypes,
    isClosedList: params.isClosedList && Array.isArray(params.isClosedList) ? params.isClosedList.join(",") : params.isClosedList,
    destinationHubIds: params.destinationHubIds && params.destinationHubIds.length > 0 ? params.destinationHubIds.join(",") : undefined,
    currentHubIds: params.currentHubIds && params.currentHubIds.length > 0 ? params.currentHubIds.join(",") : undefined,
    serviceTypes: params.serviceTypes && Array.isArray(params.serviceTypes) ? params.serviceTypes.join(",") : params.serviceTypes,
    lastTerminalStatusTimeFrom: params.lastTerminalStatusTimeFrom,
    lastTerminalStatusTimeTo: params.lastTerminalStatusTimeTo,
    lastTerminalStatuses: params.lastTerminalStatuses && Array.isArray(params.lastTerminalStatuses) ? params.lastTerminalStatuses.join(",") : params.lastTerminalStatuses,
  };
  //remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_CONTROL_TOWER_A3}?${queryString}`;
  window.open(fullUrl, "_blank");
};



/**
 * Download Eway Bill Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadEwayBillReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    hubIds: params.hubIds ? params.hubIds.join(",") : undefined,
    cpIds: params.cpIds ? params.cpIds.join(",") : undefined
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_EWAY_BILL_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Inscan Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadInscanReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    premiseIds: params.premiseIds ? params.premiseIds.join(",") : undefined,
    serviceTypes: params.serviceTypes ? params.serviceTypes.join(",") : undefined,
    documentTypes: params.documentTypes ? params.documentTypes.join(",") : undefined,
    bookingTypes: params.bookingTypes ? params.bookingTypes.join(",") : undefined,
    awbSearch: params.awbSearch ? params.awbSearch.trim() : undefined
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_INSCAN_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download MCN Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadMCNReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    originHubIds: params.originHubIds ? params.originHubIds.join(",") : undefined,
    destinationHubIds: params.destinationHubIds ? params.destinationHubIds.join(",") : undefined,
    currentHubIds: params.currentHubIds ? params.currentHubIds.join(",") : undefined,
    currentStatuses: params.currentStatuses ? params.currentStatuses.join(",") : undefined,
    bookingTypes: params.bookingType || undefined,
    doxNondoxTypes: params.doxNondoxTypes || undefined
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.GET_MCN_DOWNLOAD_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Wrong Sorting Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadWrongSortingReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    fromHubIds: params.fromHubIds ? params.fromHubIds.join(",") : undefined,
    misrouteHubIds: params.misrouteHubIds ? params.misrouteHubIds.join(",") : undefined,
    fromCenterIds: params.fromCenterIds ? params.fromCenterIds.join(",") : undefined,
    toHubIds: params.toHubIds ? params.toHubIds.join(",") : undefined,
    toCenterIds: params.toCenterIds ? params.toCenterIds.join(",") : undefined,
    serviceTypes: params.serviceTypes ? params.serviceTypes.join(",") : undefined
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_WRONG_SORTING_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Force Bag Report
 * @param {Object} params
 */
export const downloadForceBagReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    premiseIds: Array.isArray(params.premiseIds) ? params.premiseIds.join(",") : params.premiseIds
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_FORCE_BAG_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Force Shipment Scan Report
 */
export const downloadForceShipmentReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    premiseIds: Array.isArray(params.premiseIds) ? params.premiseIds.join(",") : params.premiseIds
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_FORCE_SHIPMENT_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Force Bag Attempt Shipment  Count
 * @param {Object} params
 */
export const downloadForceAttemptBagReportCount = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    premiseIds: Array.isArray(params.premiseIds) ? params.premiseIds.join(",") : params.premiseIds
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_FORCE_ATTEMPT_BAG_REPORT_COUNT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Booking vs Delivery Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadBookingVsDeliveryReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    ...(params.serviceTypes && { serviceTypes: params.serviceTypes }),
    ...(params.fromHubIds && { fromHubIds: params.fromHubIds }),
    ...(params.bookingCpIds && { bookingCpIds: params.bookingCpIds }),
    ...(params.awbNumbers && { awbNumbers: params.awbNumbers.join(",") }),
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_BOOKING_VS_DELIVERY_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Outscan By Hub To Branch Report
 * @param {Object} params - Report parameters
 * @param {string} params.fromDate - Start date in YYYY-MM-DD format
 * @param {string} params.toDate - End date in YYYY-MM-DD format
 * @param {number} [params.fromHubId] - From hub ID
 * @param {number} [params.toCpId] - To CP ID
 * @returns {Promise<void>}
 */
export const downloadOutscanByHubToBranchReport = async (params) => {
  // Use single date parameter - prefer date if provided, otherwise use fromDate
  const dateValue = params.date || params.fromDate;
  const downloadParams = {
    date: dateValue, // lowercase d for download
    ...(params.fromHubId && { fromHubId: params.fromHubId }),
    ...(params.hubId && { fromHubId: params.hubId }),
    ...(params.toCpId && { toCpId: params.toCpId }),
    ...(params.deliveryCpId && { toCpId: params.deliveryCpId })
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_OUTSCAN_BY_HUB_TO_BRANCH}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Inscan By CP Report
 * @param {Object} params - Report parameters
 * @param {string} params.fromDate - Start date in YYYY-MM-DD format
 * @param {string} params.toDate - End date in YYYY-MM-DD format
 * @param {number} [params.fromHubId] - From hub ID
 * @param {number} [params.toCpId] - To CP ID
 * @returns {Promise<void>}
 */
export const downloadInscanByCPReport = async (params) => {
  // Use single date parameter - prefer date if provided, otherwise use fromDate
  const dateValue = params.date || params.fromDate;
  const downloadParams = {
    date: dateValue, // lowercase d
    ...(params.fromHubId && { fromHubId: params.fromHubId }),
    ...(params.hubId && { fromHubId: params.hubId }),
    ...(params.toCpId && { toCpId: params.toCpId }),
    ...(params.deliveryCpId && { toCpId: params.deliveryCpId })
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_INSCAN_BY_CP}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Inscan By Other CP Report
 * @param {Object} params - Report parameters
 * @param {string} params.date - Date in YYYY-MM-DD format
 * @param {number} [params.fromHubId] - From hub ID
 * @param {number} [params.toCpId] - To CP ID
 * @returns {Promise<void>}
 */
export const downloadInscanByOtherCPReport = async (params) => {
  // Use single date parameter - prefer date if provided, otherwise use fromDate
  const dateValue = params.date || params.fromDate;
  const downloadParams = {
    date: dateValue, // lowercase d
    ...(params.fromHubId && { fromHubId: params.fromHubId }),
    ...(params.hubId && { fromHubId: params.hubId }),
    ...(params.toCpId && { toCpId: params.toCpId }),
    ...(params.deliveryCpId && { toCpId: params.deliveryCpId })
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_INSCAN_BY_OTHER_CP}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Delivery Scan By Branch Report
 * @param {Object} params - Report parameters
 * @param {string} params.fromDate - Start date in YYYY-MM-DD format
 * @param {string} params.toDate - End date in YYYY-MM-DD format
 * @param {number} [params.hubId] - Hub ID
 * @param {number} [params.deliveryCpId] - Delivery CP ID
 * @returns {Promise<void>}
 */
export const downloadDeliveryScanByBranchReport = async (params) => {
  // Use single date parameter - prefer date if provided, otherwise use fromDate
  const dateValue = params.date || params.fromDate;
  const downloadParams = {
    date: dateValue, // lowercase d
    ...(params.hubId && { hubId: params.hubId }),
    ...(params.toCpId && { toCpId: params.toCpId }),
    ...(params.deliveryCpId && { toCpId: params.deliveryCpId })
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_DELIVERY_SCAN_BY_BRANCH}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Hubwise Shipments Inscan vs Outscan Report
 * @param {Object} params - Report parameters
 * @param {string} params.fromDate - Start date in YYYY-MM-DD format
 * @param {string} params.toDate - End date in YYYY-MM-DD format
 * @param {Array<string|number>} params.hubIds - Array of hub IDs
 * @param {Array<string>} params.zones - Array of zones
 * @returns {Promise<void>}
 */
export const downloadHubwiseShipmentsInscanVsOutscanReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    hubIds: params.hubIds ? params.hubIds.join(",") : undefined,
    zones: params.zones ? params.zones.join(",") : undefined
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_HUBWISE_SHIPMENTS_INSCAN_VS_OUTSCAN_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Force Attempt Shipment Details Report
 * @param {Object} params - Report parameters
 * @param {string} params.fromDate - Start date in YYYY-MM-DD format
 * @param {string} params.toDate - End date in YYYY-MM-DD format
 * @param {number} [params.premiseId] - Premise ID
 * @returns {Promise<void>}
 */
export const downloadForceAttemptShipmentDetailsReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    ...(params.premiseId && { premiseId: params.premiseId })
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_FORCE_ATTEMPT_SHIPMENT_DETAILS}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Incoming Outgoing Shipment Details Report
 * @param {Object} params - Report parameters
 * @param {string} params.bagBarcodeNo - Bag barcode number
 * @returns {Promise<void>}
 */
export const downloadIncomingOutgoingShipmentDetailsReport = async (params) => {
  const downloadParams = {
    bagBarcodeNo: params.bagBarcodeNo
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_INCOMING_OUTGOING_SHIPMENT_DETAILS}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Hub Inscan Clickable Report
 * @param {Object} params - Report parameters
 * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
 * @param {number} params.hubId - Hub ID
 * @param {number} params.bookingCpId - Booking CP ID
 * @returns {Promise<void>}
 */
export const downloadHubInscanClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    hubId: params.hubId,
    bookingCpId: params.bookingCpId
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_HUB_INSCAN_CLICKABLE_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download CP Outscan Clickable Report
 * @param {Object} params - Report parameters
 * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
 * @param {number} params.bookingCpId - Booking CP ID
 * @param {number} params.hubId - Hub ID
 * @returns {Promise<void>}
 */
export const downloadCpOutscanClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    bookingCpId: params.bookingCpId,
    hubId: params.hubId
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_CP_OUTSCAN_CLICKABLE_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Shipment Inscan Clickable Report
 * @param {Object} params - Report parameters
 * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
 * @param {number} params.premiseId - Premise ID
 * @returns {Promise<void>}
 */
export const downloadShipmentInscanClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    premiseId: params.premiseId
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_SHIPMENT_INSCAN_CLICKABLE_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Shipment Outscan Clickable Report
 * @param {Object} params - Report parameters
 * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
 * @param {number} params.premiseId - Premise ID
 * @returns {Promise<void>}
 */
export const downloadShipmentOutscanClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    premiseId: params.premiseId
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_SHIPMENT_OUTSCAN_CLICKABLE_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Shipment Pending Clickable Report
 * @param {Object} params - Report parameters
 * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
 * @param {number} params.premiseId - Premise ID
 */
export const downloadShipmentPendingClickableReport = async (params) => {
  const downloadParams = {
    operationDate: params.operationDate,
    premiseId: params.premiseId
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_SHIPMENT_PENDING_CLICKABLE_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Excess Inscan Enhanced Report
 * @param {Object} params - Report parameters
 * @param {string} params.fromDate - Start date in YYYY-MM-DD format
 * @param {string} params.toDate - End date in YYYY-MM-DD format
 * @param {string} [params.excessInscanHubIds] - Comma-separated excess inscan hub IDs
 * @param {string} [params.bookingUpdatedHubIds] - Comma-separated booking updated hub IDs
 * @returns {Promise<void>}
 */
export const downloadExcessInscanEnhancedReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    excessInscanHubIds: params.excessInscanHubIds || "",
    bookingUpdatedHubIds: params.bookingUpdatedHubIds || ""
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_EXCESS_INSCAN_ENHANCED_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};






/**
 * Download Finalized Bags Pending Outscan Report
 * @param {Object} params - Report parameters
 * @param {string} params.fromDate - Start date in YYYY-MM-DD format
 * @param {string} params.toDate - End date in YYYY-MM-DD format
 * @param {string} [params.premiseIds] - Comma-separated premise IDs
 * @param {string} [params.destinationHubIds] - Comma-separated destination hub IDs
 * @returns {Promise<void>}
 */
export const downloadFinalizedBagsPendingOutscanReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    premiseIds: params.premiseIds || "",
    destinationHubIds: params.destinationHubIds || ""
  };

  // Remove undefined values
  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  window.open(fullUrl, "_blank");
};

/**
 * Download Same Day Delivery Clickable Report
 * @param {Object} params - Report parameters
 * @param {string} params.fromDate - Start date in YYYY-MM-DD format
 * @param {number} [params.fromHubId] - From hub ID
 * @param {number} [params.toCpId] - To CP ID
 * @returns {Promise<void>}
 */
export const downloadSameDayDeliveryClickableReport = async (params) => {
  const dateValue = params.date || params.fromDate;
  const downloadParams = {
    date: dateValue,
    fromDate: dateValue,
    ...(params.fromHubId && { fromHubId: params.fromHubId }),
    ...(params.toCpId && { toCpId: params.toCpId })
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_SAME_DAY_DELIVERY_CLICKABLE_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Shipment Inscanned v/s Weight Audited Adherence Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadShipmentInscannedVsWeightAuditedReport = async (params) => {
  const downloadParams = {
    fromDate: params.startDate,
    toDate: params.endDate,
    bookingCpIds: params.bookingCpIds ? params.bookingCpIds.join(",") : undefined,
    inscannedHubIds: params.inscannedHubIds ? params.inscannedHubIds.join(",") : undefined,
    awbNumbers: params.awbNumbers ? params.awbNumbers.join(",") : undefined
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.SHIPMENT_INSCANNED_VS_WEIGHT_AUDITED_DOWNLOAD}?${queryString}`;
  window.open(fullUrl, "_blank");
};
/**
 * Download RTO Shipment with Reason Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadRtoWithReasonReport = async (params) => {
  const downloadParams = {
    returnDatetimeFrom: params.returnDatetimeFrom,
    returnDatetimeTo: params.returnDatetimeTo,
    currentOperationTimeFrom: params.currentOperationTimeFrom,
    currentOperationTimeTo: params.currentOperationTimeTo,
    returnPremiseIds: params.returnPremiseIds ? params.returnPremiseIds.join(",") : undefined,
    currentPremiseIds: params.currentPremiseIds ? params.currentPremiseIds.join(",") : undefined,
    srcHubIds: params.srcHubIds ? params.srcHubIds.join(",") : undefined,
    destinationHubIds: params.destinationHubIds ? params.destinationHubIds.join(",") : undefined,
    docTypes: params.docTypes ? params.docTypes.join(",") : undefined,
    bookingTypes: params.bookingTypes ? params.bookingTypes.join(",") : undefined,
    awbNumbers: params.awbNumbers
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_RTO_WITH_REASON_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Non-FT Premium Bookings Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadNonFtPremiumBookingsReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    awbNumbers: params.awbNumbers,
    docTypes: params.docTypes,
    travelTypes: params.travelTypes,
    bookingTypes: params.bookingTypes,
    originHubIds: params.originHubIds
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_NON_FT_PREMIUM_BOOKINGS_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Inscanned Bags Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadInscannedBagsReport = async (params) => {
  const downloadParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    bagNumbers: params.bagNumbers,
    inscanHubIds: params.inscanHubIds
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_INSCANNED_BAGS_REPORT}?${queryString}`;
  window.open(fullUrl, "_blank");
};

/**
 * Download Hub To Hub TAT Report
 * @param {Object} params - Report parameters
 * @returns {Promise<void>}
 */
export const downloadHubToHubTatReport = async (params) => {
  const downloadParams = {
    source: params.source,
    destination: params.destination,
    mode: params.mode
  };

  const cleanParams = Object.fromEntries(
    Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const fullUrl = `${urls.DOWNLOAD_HUB_TO_HUB_TAT}?${queryString}`;
  window.open(fullUrl, "_blank");
};
